export const DISPOSAL_PROTOCOL = {
    title: '解除房屋租赁合同协议书',
    protocols: [
        {
            clauses: [
                { subtitle: '出租方：_________' },
                { subtitle: '承租方：_________' }
            ]
        },
        {
            clauses: [
                {
                    intro: '租赁双方经过平等协商，一致同意签订以下条款，以解除在六六找房上签订的编号为_________的房屋租赁合同（以下简称原合同）：',
                    examples: [
                        { text: '第一条 租赁双方约定，于_________原合同终止执行。' },
                        { text: '第二条 租赁双方按原合同约定的方式结清租赁双方各自承担的费用，具体金额和内容在补充条款里说明。' },
                        { text: '第三条 本协议系电子文本，经租赁双方在系统点击确定签订后生效。' },
                        { text: '第四条 本协议由六六找房平台留存，租赁双方可通过平台自行下载。' },
                        { text: '第五条 因本协议产生的任何纠纷，双方都应该友好协商，协商不成的，任何一方均有权向房屋所在地人民法院起诉。' },
                        { text: '第六条 补充条款补充条款内容与以上条款内容有冲突的，以补充条款为准。' },
                        { text: '___________________________', separate: true }
                    ]
                },
                {
                    examples: [
                        { text: '出租方：_________' },
                        { text: '证件号码：_________' },
                        { text: '签署时间：_________', separate: true }
                    ]
                },
                {
                    examples: [
                        { text: '承租方：_________' },
                        { text: '证件号码：_________' },
                        { text: '签署时间：_________' }
                    ]
                }
            ]
        }
    ]
}